import type {
  UpsertEventRuleMutation,
  UpsertEventRuleMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const UPSERT_EVENT_RULE: TypedDocumentNode<
  UpsertEventRuleMutation,
  UpsertEventRuleMutationVariables
> = gql`
  mutation UpsertEventRule($input: UpsertEventRuleInput!) {
    upsertEventRule(input: $input) {
      eventRule {
        id
        userId
        name
        enabled
        context
        condition
        preparation
        application
        createdAt
        updatedAt
      }
      wasCreated
    }
  }
`;
